
	import { defineComponent } from 'vue';

	import FiscalYearReportByParticipant from '@/ChildrenComponents/Reports/FiscalYearReportByParticipant.vue';

	import { IParticipantDrugTestReport, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';

    import { ReportService } from '@/Services/Report/report-service';

	export default defineComponent({
		name: 'participant-drug-test-report',
		components: { FiscalYearReportByParticipant },
		data () {
			return {
				reportData: [] as IParticipantDrugTestReport[],
				isSearching: false,
			}
		},
		methods: {
			getReportData(searchDto: IFiscalYearReportSearch) {
				this.isSearching = true;
				ReportService.getParticipantDrugTestReportData(searchDto).then(response => this.reportData = response).finally(() => this.isSearching = false);
			}
		},
	});
